module.exports = __webpack_public_path__ + "files/Formato.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Formato.xlsx
// module id = eIyA
// module chunks = 1